import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API;

export const axiosFetcher = async (url: string) => {
  const response = await axios.get(url, {
    
    withCredentials:true
  });
  return response.data;
};





// Fonctions pour les roles de l'application
export const getRoles = (applicationId: string,  ) => {
   const companyId= localStorage.getItem('company')
  return axiosFetcher(`${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/role`);
};

export const addRole = async (companyId: string, applicationId: string, name: string) => {
  return axios.post(
    `${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/role`,
    { name },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
};

export const editRole = async (companyId: string, appId: string, roleId: string, name: string) => {
  return axios.put(
    `${API_BASE_URL}/Company/${companyId}/applications/${appId}/roles/${roleId}`,
    { name },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
};

export const importRolesFromCSV = async (companyId: string, appId: string, roles: string[]) => {
  return axios.post(
    `${API_BASE_URL}/Company/${companyId}/applications/${appId}/roles/batch`,
    { roles },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
};

export const deleteRole = async (companyId: string, appId: string, roleId: string) => {
  return axios.delete(
    `${API_BASE_URL}/Company/${companyId}/applications/${appId}/roles/${roleId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
};

//
export const ApplicationRolesService = {
  // Récupérer tous les rôles
  getAll: async (companyId: string, applicationId: string) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/role`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Ajouter un rôle
  create: async (companyId: string, applicationId: string, roleData: { name: string }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/role`,
        roleData.name,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Mettre à jour un rôle
  update: async (companyId: string, applicationId: string, roleId: string, roleData: { name: string }) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/roles/${roleId}`,
        roleData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Supprimer un rôle
  delete: async (companyId: string, applicationId: string, roleName: string) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/role/${roleName}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Importer plusieurs rôles
  batchImport: async (companyId: string, applicationId: string, roles: string[]) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/roles/batch`,
        { roles },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};

// Gestion centralisée des erreurs
const handleApiError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      // Erreur avec réponse du serveur
      const message = error.response.data?.message || error.response.statusText;
      return new Error(`API Error: ${message} (${error.response.status})`);
    } else if (error.request) {
      // Pas de réponse du serveur
      return new Error('No response received from server');
    }
  }
  // Erreur inattendue
  return error instanceof Error ? error : new Error('An unknown error occurred');
};

// Méthodes utilitaires pour la compatibilité
export const getApplicationRoles = getRoles;
export const createApplicationRole = addRole;
export const updateApplicationRole = editRole;
export const removeApplicationRole = deleteRole;













// import axios from 'axios';

// const API_BASE_URL = import.meta.env.VITE_API;

// export const axiosFetcher = async (url: string) => {
//   const response = await axios.get(url, {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//     },
//   });
//   return response.data;
// };

// export const getRoles = (companyId: string, applicationId: string) => {
//   return axiosFetcher(`${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/role`);
// };

// export const addRole = async (companyId: string, applicationId: string, name: string) => {
//   return axios.post(
//     `${API_BASE_URL}/Company/${companyId}/applications/${applicationId}/role`,
//     { name },
//     {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//       },
//     }
//   );
// };

// export const editRole = async (companyId: string, appId: string, roleId: string, name: string) => {
//   return axios.put(
//     `${API_BASE_URL}/Company/${companyId}/applications/${appId}/roles/${roleId}`,
//     { name },
//     {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//       },
//     }
//   );
// };

// export const importRolesFromCSV = async (companyId: string, appId: string, roles: string[]) => {
//   return axios.post(
//     `${API_BASE_URL}/Company/${companyId}/applications/${appId}/roles/batch`,
//     { roles },
//     {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//       },
//     }
//   );
// };

// export const deleteRole = async (companyId: string, appId: string, roleId: string) => {
//   return axios.delete(
//     `${API_BASE_URL}/Company/${companyId}/applications/${appId}/roles/${roleId}`,
//     {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//       },
//     }
//   );
// };